import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LINK_PATH } from '../../constant';
import { useDropdownKeyboardNavigation } from '../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import NavigationList from '../../components/NavigationList/NavigationList';
import useKeyboardNavigation from '../../components/Custom_Hooks/useKeyboardNavigation';

const GateWayOfTally = (props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const { userData = null } = useSelector((state) => state.auth);

    const hasPermission = React.useCallback((reportName) => {
        if (userData?.login_type === 'user' && Array.isArray(userData?.permissions)) {
            const pagePermissions = userData.permissions.find(p => p.name?.toLowerCase() === reportName?.toLowerCase() && p.category?.toLowerCase() === 'reports');
            return pagePermissions ? !!pagePermissions.view : false;
        }
        return true;
    }, [userData]);

    const keyMap = {
        /*'c': '/createmasters',*/
        'd': '/displaymorereports',
        'h': '/chartofaccountmasters',
        'v': '/voucherstransaction',
        'p': hasPermission('Profit & Loss') ? '/profitandlossac' : '',
        's': hasPermission('Stock Summary') ? '/stocksummary' : '',
        'k': hasPermission('DayBook') ? (nav) => nav('/daybooktransaction', { state: { resetId: Date.now() } }) : '',
        'b': hasPermission('Balance Sheet') ? '/balancesheetreports' : '',
        //'r': '/displaymorereports',
    };
    useKeyboardNavigation(keyMap);
    const data = [
        /*{ to: '/createmasters', text: 'Create', category: 'Master' },*/
        { to: '/chartofaccountmasters', text: 'Chart of Accounts', category: 'Master' },

        { to: '/voucherstransaction', text: 'Vouchers', category: 'Transaction' },
        ...(hasPermission('DayBook') ? [{ to: '/daybooktransaction', text: 'Day Book', category: 'Transaction', state: { resetId: Date.now() } }] : []),

        { to: '/bankingutilities', text: 'Banking', category: 'Utilities' },

        ...(hasPermission('Balance Sheet') ? [{ to: `${LINK_PATH}/balancesheetreports`, text: 'Balance Sheet', category: 'Reports' }] : []),
        ...(hasPermission('Profit & Loss') ? [{ to: '/profitandlossac', text: 'Profit & Loss A/c', category: 'Reports' }] : []),
        ...(hasPermission('Stock Summary') ? [{ to: '/stocksummary', text: 'Stock Summary', category: 'Reports' }] : []),
        { to: '/displaymorereports', text: 'Display More Reports', category: 'Reports' },
    ];

    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: data,
        // state: location.pathname==='/create-master-group'|| location.pathname==='/create-master-ledger'|| location?.pathname==='/create-master-invmas-stockgroup'?false:true,
        state: location.pathname === '/' ? true : false,
        onItemSelect: (item) => {
            // if (['/ledgerbook', '/current_date', '/period', '/create-master-group', '/create-master-ledger', '/create-master-invmas-stockgroup'].includes(location.pathname)) {
            //     return;
            // }
            const isBasePath = location.pathname === '/' || location.pathname === LINK_PATH || location.pathname === `${LINK_PATH}/`;
            if (isBasePath) {
                if (item.state) {
                    navigate(item.to, { state: item.state })
                } else {
                    navigate(item.to)
                }
            }
        },

    });
    return (
        <NavigationList
            data={data}
            selectedItemIndex={selectedItemIndex}
            setSelectedItemIndex={setSelectedItemIndex}
            title='Gateway Of Tally'
            first_heading='Master'
        />
    )
}

export default React.memo(GateWayOfTally)